export default "__VITE_ASSET__CjZeoRpA__"